import React, { useState, useEffect } from "react";
import "./Tour.css";
import CloseIcon from "../../assets/svg/CloseIcon";
import { useAdminContext } from "../../services/context/TourPopupContext";
import Button from "../organism/Button";
import { useHistory } from "react-router-dom";
import { createPortal } from "react-dom";
import CustomText from "../atomic/CustomText";

interface Step {
  target: string;
  heading: string;
  content: string;
  position?: "top" | "right" | "bottom" | "left";
  highlightStyle?: React.CSSProperties;
  tooltipStyle?: React.CSSProperties;
  positionAdjustment?: {
    top?: number;
    left?: number;
    right?: number;
  };
}
interface TourProps {
  onClose: () => any;
}

const steps: Step[] = [
  {
    target: "#step1",
    heading: "New Call to Action Zone",
    content:
      "Featuring the most utilized functions in the portal. Quickly access key functions and jump into tasks with ease.",
    position: "right",
    // tooltipStyle: { marginTop: "-200px", marginLeft: "10px" },
    // tooltipStyle: getResponsiveTooltipStyle(0),
  },
  {
    target: "#step2",
    heading: "Optimized Patient Search",
    content:
      "We've upgraded our patient-oriented search to make finding what you need easier than ever. With intuitive features and enhanced functionality, you can now navigate through patient data effortlessly. ",
    position: "bottom",
    positionAdjustment: {
      top: 0,
      left: 200,
    },
    // tooltipStyle: { marginTop: "10px", marginLeft: "-215px" },
    // tooltipStyle: getResponsiveTooltipStyle(1),
  },
  {
    target: "#step3",
    heading: "Patients section",
    content:
      "Welcome to our new Patients Section. Here, you'll find everything you need to manage patient interactions efficiently. From comprehensive patient lists to detailed history and profiles.",
    position: "right",
    positionAdjustment: {
      top: 100,
      left: 0,
    },
    // tooltipStyle: { marginTop: "-45px", marginLeft: "8px" },
    // tooltipStyle: getResponsiveTooltipStyle(2),
  },
  {
    target: "#step4",
    heading: "Improved Section Layouts",
    content:
      "We've fine-tuned the layout and design of key sections within the portal. Accessing help, notifications, and your profile dropdown is now more intuitive than ever. Stay informed, get assistance, and manage your profile effortlessly with our upgraded interface.",
    position: "bottom",
    positionAdjustment: {
      top: 5,
      left: -20,
    },
    // tooltipStyle: { marginLeft: "-300px", marginTop: "10px" },
    // tooltipStyle: getResponsiveTooltipStyle(3),
  },
  {
    target: "#step5",
    heading: "Patient Creation",
    content:
      "We've simplified the process of ordering tests online. This feature allows you to swiftly input and save patient information for future orders. Enter patient details once and easily access them for subsequent test orders.",
    position: "right",
    positionAdjustment: {
      top: 350,
      right: -380,
    },
    // tooltipStyle: { marginLeft: "-700px", marginTop: "150px" },
    // tooltipStyle: getResponsiveTooltipStyle(4),
  },
  {
    target: "#step6",
    heading: "Updated online test section ",
    content:
      "Our enhanced user interface neatly organizes all Castle test offerings, neatly categorized for easy navigation. Plus, introducing a new favorite test feature – mark your most-used tests for quick access.",
    position: "left",
    positionAdjustment: {
      top: -500,
      left: -20,
    },
    // tooltipStyle: { marginLeft: "-80vw", marginTop: "250px" },
    // tooltipStyle: getResponsiveTooltipStyle(5),
  },
  {
    target: "#step7",
    heading: "Attach documents to existing order or Drop-off Documents",
    content:
      "Welcome to our refreshed Test section! We've transformed the user interface ( UI ) design to enhance your experience. Say goodbye to checkboxes and hello to visually appealing test cards, neatly categorized for easy navigation. Plus, introducing a new favorite test feature - mark your most-used tests for quick access. With these updates, managing tests is simpler and more intuitive than ever before. Dive in and discover seamless efficiency with our updated UI",
    position: "right",
    positionAdjustment: {
      top: 0,
      left: 10,
    },

    // tooltipStyle: { marginLeft: "-80vw", marginTop: "250px" },
    // tooltipStyle: getResponsiveTooltipStyle(6),
  },
];

function ToolTip({
  currentStep,
  getTooltipStyle,
  handleClose,
  handlePrev,
  handleNext,
  handleDone,
  renderStepDots,
}: any) {
  const [show, setShow] = useState(false);

  useEffect(() => {
    setShow(true);
  }, [currentStep]);

  if (show)
    return (
      <div
        className="tour-tooltip"
        key={currentStep}
        style={{
          ...getTooltipStyle(),
          top: currentStep === 4 ? "50vh" : getTooltipStyle().top,
          left: currentStep === 4 ? "70vw" : getTooltipStyle().left,
        }}
        data-position={steps[currentStep]?.position}
      >
        {/* Tooltip Header */}
        <div className="tooltip-header">
          <CustomText
            text={steps[currentStep]?.heading}
            fontWeight="font-medium"
            className="text-xl"
          />
          <button className="close-button" onClick={handleClose}>
            <CloseIcon />
          </button>
        </div>
        {/* Content */}
        <CustomText
          text={steps[currentStep]?.content}
          fontWeight="font-normal"
          className="my-5 text-base"
        />
        {/* Controls */}
        <hr />
        {/* Step Dots */}
        <div className="tour-controls">
          {renderStepDots()}
          <div className="flex justify-end w-full">
            {currentStep > 0 && (
              <Button
                buttonTheme="secondary"
                textInformation={{
                  text: "BACK",
                  fontWeight: "font-semibold",
                }}
                className="mr-3"
                onClick={handlePrev}
              />
            )}
            {currentStep < steps.length - 1 ? (
              <Button
                buttonTheme="primary"
                textInformation={{
                  text: "NEXT",
                  fontWeight: "font-semibold",
                }}
                onClick={handleNext}
              />
            ) : (
              <Button
                buttonTheme="primary"
                textInformation={{
                  text: "Done",
                  fontWeight: "font-semibold",
                }}
                onClick={handleDone}
              />
            )}
          </div>
        </div>
      </div>
    );
  return null;
}
const Tour: React.FC<TourProps> = ({ onClose }) => {
  const [currentStep, setCurrentStep] = useState(0);
  const history = useHistory();
  const [highlightedElement, setHighlightedElement] =
    useState<HTMLElement | null>(null);
  const [showTooltip, setShowTooltip] = useState<boolean>(true);
  const { setIsPatientPopupEnabled, isPatientPopupEnabled } = useAdminContext();
  const renderStepDots = () => (
    <div className="step-dots">
      {steps.map((_, index) => (
        <span
          key={index}
          className={`step-dot ${index === currentStep ? "active" : ""}`}
          // onClick={() => setCurrentStep(index)}
        />
      ))}
    </div>
  );
  useEffect(() => {
    if (highlightedElement) {
      highlightedElement.classList.remove("content-highlight");
    }

    if (currentStep <= steps.length) {
      const element = document.querySelector(
        steps[currentStep].target
      ) as HTMLElement;

      if (element) {
        element.classList.add("content-highlight");
        setHighlightedElement(element);
      }
    } else {
      setHighlightedElement(null);
    }
  }, [currentStep, highlightedElement]);

  const handleNext = () => {
    switch (currentStep + 1) {
      case 4:
        setIsPatientPopupEnabled(true);
        setCurrentStep((prev) => prev + 1);
        break;
      case 5:
        setIsPatientPopupEnabled(false);
        setShowTooltip(false);
        setCurrentStep((prev) => prev + 1);
        setTimeout(() => {
          history.push("/access/online-order", { tourPopup: true });
          setTimeout(() => {
            const element = document.querySelector(
              steps?.[5]?.target
            ) as HTMLElement;
            if (element) {
              element.classList.add("content-highlight");
              setHighlightedElement(element);
            }
            setShowTooltip(true);
          }, 300); // Increased delay for rendering
        }, 300);
        break;
      case 6:
        setCurrentStep((prev) => prev + 1);
        setIsPatientPopupEnabled(false);
        setShowTooltip(false);
        setTimeout(() => {
          history.push("/access/documents", { tourPopup: true });
          setTimeout(() => {
            const element = document.querySelector(
              steps?.[6]?.target
            ) as HTMLElement;
            if (element) {
              element.classList.add("content-highlight");
              setHighlightedElement(element);
            }
            setShowTooltip(true);
          }, 300);
        }, 300);
        break;

      default:
        setCurrentStep((prev) => prev + 1);
        break;
    }
  };

  const handlePrev = () => {
    switch (currentStep) {
      case 4:
        setCurrentStep((prev) => prev - 1);
        setIsPatientPopupEnabled(false);

        break;
      case 5:
        setCurrentStep((prev) => prev - 1);
        setIsPatientPopupEnabled(true);
        setTimeout(() => {
          history.push("/access/dashboard");
          setTimeout(() => {
            setShowTooltip(true);
          }, 1000);
        }, 100);
        break;

      case 6:
        setShowTooltip(false);
        setCurrentStep((prev) => prev - 1);
        setTimeout(() => {
          history.push("/access/online-order", { tourPopup: true });
          setTimeout(() => {
            const element = document.querySelector(
              steps?.[5]?.target
            ) as HTMLElement;
            if (element) {
              element.classList.add("content-highlight");
              setHighlightedElement(element);
            }
            setShowTooltip(true);
          }, 300); // Increased delay for rendering
        }, 300);
        break;

      default:
        setCurrentStep((prev) => prev - 1);
        break;
    }
  };

  const handleClose = () => {
    if (highlightedElement) {
      highlightedElement.classList.remove("content-highlight");
    }
    setHighlightedElement(null);
    setIsPatientPopupEnabled(false);
    setCurrentStep(steps.length);
    onClose();
  };

  const handleDone = () => {
    onClose();
    setIsPatientPopupEnabled(false);
  };
  useEffect(() => {
    const handleResizeOrScroll = () => {
      // Force re-render to update positions
      setShowTooltip(false);
      setTimeout(() => setShowTooltip(true), 100);
    };

    window.addEventListener("resize", handleResizeOrScroll);
    window.addEventListener("scroll", handleResizeOrScroll, true);

    return () => {
      window.removeEventListener("resize", handleResizeOrScroll);
      window.removeEventListener("scroll", handleResizeOrScroll, true);
    };
  }, []);

  const getTooltipStyle = (): React.CSSProperties => {
    if (!highlightedElement) return {};

    const rect = highlightedElement.getBoundingClientRect();
    const position = steps[currentStep]?.position || "bottom";
    const scrollX = window.scrollX;
    const scrollY = window.scrollY;
    const adjustment = steps[currentStep]?.positionAdjustment || {
      top: 0,
      left: 0,
    };

    const baseStyles = {
      position: "absolute",
      zIndex: 99999,
      ...steps[currentStep]?.tooltipStyle,
    };

    switch (position) {
      case "top":
        return {
          ...baseStyles,
          position: "absolute",
          top: rect.top + scrollY,
          left: rect.left + rect.width / 2 + scrollX,
          transform: "translateX(-50%) translateY(-100%)",
          marginTop: "-10px",
        };
      case "right":
        return {
          ...baseStyles,
          position: "absolute",
          top: rect.top + rect.height / 2 + scrollY + (adjustment.top || 0),
          left: rect.right + scrollX + (adjustment.right || 0),
          transform: `translateY(calc(-50% - ${
            currentStep === 4 ? 0 : adjustment.top
          }px))`,
          marginLeft: "10px",
        };
      case "bottom":
        return {
          ...baseStyles,
          position: "absolute",
          top: rect.bottom + scrollY + (adjustment.top || 0),
          left: rect.left + scrollX + (adjustment.left || 0),
          transform: "translateX(-50%)",
          marginTop: "10px",
        };
      case "left":
        return {
          ...baseStyles,
          position: "absolute",
          top: rect.top + rect.height / 2 + scrollY + (adjustment.top || 0),
          left: rect.left + scrollX + (adjustment.left || 0),
          transform: "translateY(-50%) translateX(-100%)",
          marginRight: "10px",
        };
      default:
        return baseStyles as React.CSSProperties;
    }
  };

  return (
    <>
      {highlightedElement && (
        <div className="tour-overlay">
          <div
            className="tour-highlight"
            style={{
              top: highlightedElement.offsetTop,
              left: highlightedElement.offsetLeft,
              width: highlightedElement.offsetWidth,
              height: highlightedElement.offsetHeight,
              ...steps[currentStep]?.highlightStyle, // Apply custom styles
            }}
          />
          {showTooltip &&
            createPortal(
              <ToolTip
                currentStep={currentStep}
                getTooltipStyle={getTooltipStyle}
                handleClose={handleClose}
                handlePrev={handlePrev}
                handleNext={handleNext}
                handleDone={handleDone}
                renderStepDots={renderStepDots}
              />,
              document.body
            )}
        </div>
      )}
    </>
  );
};

export default Tour;
